import { gql } from "@apollo/client";

export const GET_PUBLIC_BLOGS = gql`
    query GetPublicBlogs($page: Int, $limit: Int, $category: String, $tag: String, $search: String) {
        getPublicBlogs(page: $page, limit: $limit, category: $category, tag: $tag, search: $search) {
            data {
                id
                title
                slug
                summary
                coverImage
                categories
                tags
                readingTime
                publishedAt
            }
            total
            pages
            page
        }
    }
`;

export const GET_BLOG_POST_PUBLIC = gql`
    query GetBlogPostPublic($slug: String!) {
        getBlogPostBySlug(slug: $slug) {
            id
            title
            content
            slug
            summary
            coverImage
            categories
            tags
            seoTitle
            metaDescription
            readingTime
            publishedAt
            updatedAt
            author {
                firstName
                lastName
            }
        }
    }
`;

export const GET_RECENT_BLOGS = gql`
    query GetRecentBlogs($limit: Int) {
        getRecentBlogs(limit: $limit) {
            id
            title
            slug
            coverImage
            summary
            publishedAt
            readingTime
        }
    }
`;

export const GET_POPULAR_BLOGS = gql`
    query GetPopularBlogs($limit: Int) {
        getPopularBlogs(limit: $limit) {
            id
            title
            slug
            coverImage
            summary
            publishedAt
            readingTime
        }
    }
`;

export const GET_MOST_VIEWED_BLOGS = gql`
    query GetMostViewedBlogs($limit: Int) {
        getMostViewedBlogs(limit: $limit) {
            id
            title
            slug
            coverImage
            summary
            publishedAt
            readingTime
        }
    }
`;

export const GET_BLOG_CATEGORIES = gql`
    query GetBlogCategories {
        getBlogCategories
    }
`;

export const GET_BLOG_TAGS = gql`
    query GetBlogTags {
        getBlogTags
    }
`;
